import { markRaw, defineAsyncComponent } from 'vue';
import type { DiscoveredRouteModule } from '@/router/generator/types';

// Components
const PortalChannelsIndexView = () => import('@/views/portal/channels/IndexView.vue');
const PortalChannelsEditView = () => import('@/views/portal/channels/EditView.vue');
const PortalChannelsViewView = () => import('@/views/portal/channels/ViewView.vue');
const PortalChannelsAdminView = () => import('@/views/portal/channels/AdminView.vue');
const PortalChannelsView = () => import('@/views/portal/ChannelsView.vue');

// Header components used via meta.dynamicComponent
const PortalChannelsHeaderComponent = defineAsyncComponent(() => import('@/components/app/portal/channels/header-components/IndexHeader.vue'));
const ViewHeader = defineAsyncComponent(() => import('@/components/app/portal/channels/header-components/ViewHeader.vue'));
const EditHeader = defineAsyncComponent(() => import('@/components/app/portal/channels/header-components/EditHeader.vue'));
const AdminHeader = defineAsyncComponent(() => import('@/components/app/portal/channels/header-components/AdminHeader.vue'));

// Names and path
export const NAME_PORTAL_CHANNELS = 'PortalChannels';
export const NAME_PORTAL_CHANNELS_INDEX = 'PortalChannelsIndex';
export const NAME_PORTAL_CHANNELS_EDIT = 'PortalChannelsEdit';
export const NAME_PORTAL_CHANNELS_VIEW = 'PortalChannelsView';
export const NAME_PORTAL_CHANNELS_ADMIN = 'PortalChannelsAdmin';
export const PATH_PORTAL_CHANNELS = 'portal/channels';

export const route: DiscoveredRouteModule = {
  id: 'app.portal.channels',
  scope: 'app',
  moduleKey: 'channels',
  name: NAME_PORTAL_CHANNELS,
  path: PATH_PORTAL_CHANNELS,
  component: PortalChannelsView,
  // Wrapper route redirects to index child; legacy module keeps wrapper layout if needed
  redirect: { name: NAME_PORTAL_CHANNELS_INDEX },
  children: [
    {
      path: '',
      component: PortalChannelsIndexView,
      name: NAME_PORTAL_CHANNELS_INDEX,
      meta: {
        dynamicComponent: markRaw(PortalChannelsHeaderComponent),
        dynamicComponentScale: 'scale-75',
        dataLoaders: ['project_channels', 'algolia', 'portal_base']
      }
    },
    {
      path: ':id/edit',
      component: PortalChannelsEditView,
      name: NAME_PORTAL_CHANNELS_EDIT,
      meta: {
        dynamicComponent: markRaw(EditHeader),
        dynamicComponentScale: 'scale-75',
        allowedRoles: ['admin', 'owner'],
        dataLoaders: ['project_channels', 'active_project_channel', 'algolia', 'portal_base']
      }
    },
    {
      path: ':id/view',
      component: PortalChannelsViewView,
      name: NAME_PORTAL_CHANNELS_VIEW,
      meta: {
        dynamicComponent: markRaw(ViewHeader),
        dynamicComponentScale: 'scale-75',
        dataLoaders: ['project_channels', 'active_project_channel', 'algolia', 'portal_base']
      }
    },
    {
      path: ':id/admin',
      component: PortalChannelsAdminView,
      name: NAME_PORTAL_CHANNELS_ADMIN,
      meta: {
        dynamicComponent: markRaw(AdminHeader),
        dynamicComponentScale: 'scale-75',
        requiresAdmin: true,
        allowedRoles: ['admin'],
        dataLoaders: ['project_channels', 'active_project_channel', 'algolia', 'portal_base']
      }
    }
  ],
  meta: {
    requiresFeature: 'channels'
  }
};


